const routes = [
  {
    index: true,
    label: "Yuehao Shi",
    path: '/index',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Resume',
    path: '/resume', 
  },
  {
    label: 'Projects',
    path: '/projects',
  },
  {
    label: 'Games',
    path: '/games',
  },
];

export default routes;
